<template>
  <div>
    <div v-if = "CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN.length>0" class="alert-container mb-2" >
              <div class="fade-in-out alert alert-error" >
                <div><strong>{{CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN}}</strong></div>
              </div>
            </div>
    <div class="mt-5 container pl-md-0 pr-md-0" v-show="!routeParamId">
      <div class="row">
        <div
          class="
            home-nav-container
            p-0
            col-lg-3 col-xl-2
            h-100
            d-none d-lg-block
          "
        >
          <scrollactive
            class="home-nav"
            active-class="active"
            highlight-first-item
            :offset="360"
            :duration="600"
            bezier-easing-value=".5,0,0.90,1"
            @itemchanged="onItemChanged"
          >
<!--            Adding top-20 and bottom-20 css values programmatically to support IE.-->
            <ul class="scroll-list hide-on-small-height" :class="setTop20 ? 'top-20': setBottom20 ? 'bottom-20':''">
              <li v-for="(item, index) in topLevelSections" :key="item.id">
                <a
                  :href="'/#' + item.jumpLink"
                  class="scrollactive-item"
                  v-bind:class="[index === 0 ? 'active' : '']"
                  @click="trackJumpLinkChanges(item.name)"
                  >{{ item.name }}
                </a>
              </li>
            </ul>
          </scrollactive>
        </div>
        <div class="col-lg-8 offset-xl-1 p-0 col-12-on-small-height">
          <div
            :id="item.jumpLink"
            v-for="item in topLevelSections"
            :key="item.id"
            data-aos="fade-up"
            data-aos-duration="800"
            class="mb-5 pt-5"
          >
            <carousel-branch
              v-if="item.displayType === 'Carousel'"
              :sectionId="item.id"
            ></carousel-branch>
            <standard-branch v-else :sectionId="item.id"></standard-branch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import AOS from "aos";
import "aos/dist/aos.css";
import { mapGetters, mapActions } from "vuex";
import CarouselBranch from "@/components/homepage/CarouselBranch";
import StandardBranch from "@/components/homepage/StandardBranch";
import CardDecisionBranchModal from "./CardDecisionBranchModal";
AOS.init();
Vue.use(VueScrollTo);
export default {
  components: {
    CarouselBranch,
    StandardBranch,
  },
  data() {
    return {
      setTop20: false,
      setBottom20: false,
      NAV_END_THRESHOLD_HEIGHT : 4600,
      NAV_START_THRESHOLD_HEIGHT : 150
    }
  },
  mounted() {
    this.navigateToHash()
    this.scrollHomepageLeftNav()
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.handleHomePageScroll);
  },
  methods: {
    ...mapActions(["fetchDecisionBranches"]),
    scrollHomepageLeftNav(){
      document.addEventListener("scroll",this.handleHomePageScroll)
    },
    handleHomePageScroll() {
      //using pageYOffset instead of scrollY to support IE
      //using NAV_START_THRESHOLD_HEIGHT & NAV_END_THRESHOLD_HEIGHT to programmatically set the nav-menu in the respective section of the page irrespective of any screen window size.
      let scrollPercent = window.pageYOffset;
      this.setTop20 = scrollPercent > this.NAV_START_THRESHOLD_HEIGHT && scrollPercent < this.NAV_END_THRESHOLD_HEIGHT;
      this.setBottom20 = scrollPercent > this.NAV_END_THRESHOLD_HEIGHT
    },
      navigateToHash() {
      let that = this
      Vue.nextTick(function () {
        if (that.$route.hash) {
          let hash = that.$route.hash;
          if (!hash || hash === "#" || hash === "#/") {
            window.scrollTo(0, 0);
            return;
          }
          that.$scrollTo(hash, 300, {
            easing: "linear",
          });

          let attrName = hash.replace("#", "");
          that.$scrollTo(`a[name=${attrName}]`, 300, {
            easing: "linear",
          });
        }
      });
    },
    onItemChanged(event, currentItem) {
      let topLevelItems = JSON.parse(JSON.stringify(this.topLevelSections))
      topLevelItems.sort((a,b) => a.ehOrder - b.ehOrder)
      let lastJumpLink = topLevelItems[topLevelItems.length-1]

    },
    getPlainText(html) {
      let tempDivElement = document.createElement("div");
      tempDivElement.innerHTML = html;
      return tempDivElement.innerText
    },
    pageScrolled() {
      let that = this
      window.onscroll = function() {
        that.scrollPagePercent = ((window.pageYOffset + window.innerHeight)/document.body.offsetHeight) * 100
      };
    },
    trackJumpLinkChanges(jumpLink) {
      let event = 'Supplier central home - side nav selected'
      let subEvent = jumpLink
      this.$hhMixpanel.trackEvent(event, {subEvent: subEvent})
    },
    async loadDecisionBranches() {
      await this.fetchDecisionBranches();
      this.navigateToHash()
      if(this.$route.params && this.$route.params.id){
        this.$modal.show(
            CardDecisionBranchModal,
            {"cardId": this.$route.params.id},
            {
              height: "auto",
              transition: "fade",
              scrollable: true,
              adaptive: true,
              name:'CardDecisionBranchModal'
            },
            {
              "before-close": () => {
                this.$router.push("/").catch(()=>{});
              }
            }
        );
      }else{
          this.$modal.hide("CardDecisionBranchModal")
      }
    },
  },
  created() {
    this.loadDecisionBranches();
  },
  computed: {
    routeParamId(){
      return this.$route.params && this.$route.params.id;
    },
    ...mapGetters(["decisionBranches", "isLoading"]),
    topLevelSections() {
      return this.decisionBranches.sections
        .filter((item) => !item.parent)
        .sort((a, b) => a.ehOrder - b.ehOrder);
    },
    isScrollPastThreshold(){
      this.pageScrolled()
      return this.scrollPagePercent >= this.SCROLL_THRESHOLD
    }
  },
};
</script>

<style scoped>
.top-20 {
  position: fixed;
  top:20rem;
}
.bottom-20{
  position: fixed;
  bottom:50rem;
}

@media screen and (max-height: 680px) {
  .hide-on-small-height {
    display: none;
  }
  .col-12-on-small-height {
    margin-left: 0 !important;
    -ms-flex: 0 0 100% !important;
    -webkit-box-flex: 0 !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
<style>
/* Hide in ipad pro screen size*/
@media (max-width: 900px) {
  .home-nav-container {
    visibility: hidden;
  }
}

.home-nav {
  font-size: 16px;
  color: #000;
}



.scroll-list {
  list-style-type: none;
  padding-inline-start: 0;
  width: 200px;
}

@media (max-width: 1280px) {
  .scroll-list {
    width: 300px;
  }
}

.scroll-list li {
  margin-bottom: 15px;
  display: flex;
}
.scroll-list li a {
  padding-left: 15px;
}

.active {
  color: var(--secondary-color) !important;
  font-weight: 700;
  font-size: 18px;
  border-left: 5px solid;
  font-family: artifaktElementBold;
  cursor: pointer;
}

.child-title {
  font-size: 18px;
  color: #000;
  font-family: artifaktElementBoldHH;
}

.child-card {
  height: 300px;
}

.card-header {
  background: #fff !important;
  border: none;
  border-bottom: none !important;
}

.card-link {
  font-size: 14px;
  font-weight: 700;
}

.action-lnk {
  text-decoration: none;
  color: #000;
}

.scrollactive-item {
  font-weight: 700;
  color: #000000 !important;
}

.scrollactive-item.active {
  color: var(--secondary-color) !important;
}
</style>